import { pluralise } from '@lib/utils';

type VehicleBranchProps = {
  name: string;
  url: string;
  distance_to_customer?: number;
  icon?: string;
  nofollow?: boolean;
  prefix?: string;
};

const VehicleBranch = ({
  name,
  url,
  distance_to_customer,
  icon,
  nofollow,
  prefix,
}: VehicleBranchProps) => {
  const renderDistanceText = (distance: number): string => {
    const roundedDistance = Math.floor(distance);
    return roundedDistance < 1
      ? ' (Less than 1 mile)'
      : ` (${roundedDistance} ${pluralise(roundedDistance, 'mile')})`;
  };

  return (
    <a
      className={`branchname${icon ? ' branchname--' + icon : ''}`}
      href={url.toLowerCase()}
      rel={nofollow ? 'nofollow' : undefined}
    >
      {prefix && <span className="ch-flex--none">{prefix} </span>}
      <span className="ch-text--bold ch-text--ellipsis">{name}</span>
      {typeof distance_to_customer === 'number' && (
        <span className="ch-flex--none">
          {renderDistanceText(distance_to_customer)}
        </span>
      )}
    </a>
  );
};

export default VehicleBranch;
